<div class="toll-free-notification-modal">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
    <div class="notification-icon">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    </div>
    
    <div class="notification-content">
      <h4 class="notification-title">Service Notification</h4>
      <p class="notification-message">
        Our toll-free number will be down on <strong>27th September 2025</strong> due to maintenance activity. 
        You can raise your queries at <a href="#" (click)="mailTo('mfassist@itiorg.com')" class="email-link">mfassist&#64;itiorg.com</a>.
      </p>
    </div>
    
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="closeModal()">
        Got it
      </button>
    </div>
  </div>
</div>
